/**
 * Text an agent copies or shares with a vendor.
 * The link is the last thing in the message so a preview card can attach.
 * Share uses this same text and also puts the link in the url field.
 */

function vendorInviteMessage(agentName, link) {
  const name = String(agentName || "").replace(/\s+/g, " ").trim();
  const intro = name
    ? `Hi, it's ${name}. I'd like to add you to my vendor list on Pacarion so my clients can find you.`
    : "Hi, I'd like to add you to my vendor list on Pacarion so my clients can find you.";
  return `${intro} This link works once: ${link}`;
}

function vendorInviteMessageForProfile(profile, link) {
  const name = `${(profile && profile.first_name) || ""} ${(profile && profile.last_name) || ""}`.trim();
  return vendorInviteMessage(name, link);
}

module.exports = {
  vendorInviteMessage,
  vendorInviteMessageForProfile,
};
